"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWebhookSignature = void 0;
const crypto_1 = __importDefault(require("crypto"));
/**
 * Computes the value to be used for the X-WEBHOOK-SIGNATURE header for webhook calls.
 * See https://shapediver.atlassian.net/wiki/spaces/SS/pages/2184839185/Platform+Backend+-+Webhook+receivers#Verification-of-request-body
 * @param secret
 * @param body
 * @returns
 */
function createWebhookSignature(secret, body) {
    const hmac = crypto_1.default.createHmac('sha256', Buffer.from(secret, 'utf-8'));
    const json = JSON.stringify(body);
    hmac.update(Buffer.from(json, 'utf-8'));
    const hashBytes = hmac.digest();
    return hashBytes.toString('hex').toLowerCase();
}
exports.createWebhookSignature = createWebhookSignature;
//# sourceMappingURL=SdWebhookSignature.js.map